import React from 'react'
import './Summary.css'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import {setTotal} from "../../redux/reducer"
import { useDispatch } from 'react-redux'
import { setStep } from '../../redux/reducer'


const Summary = () => {

  
  const dispatch=useDispatch()
  const planDuration = useSelector((state) => state.planDuration)
  const plan = useSelector((state) => state.plan)
  const addOns = useSelector((state) => state.addOns)
  const Total=useSelector((state) => state.Total)
  const step=useSelector((state)=>state.step)

  useEffect(()=>{
    dispatch(setTotal())


  },[])
  return (
    <div className="summary">

      <div className="summaryCard">

        {/* Plan Section */}
        <div className="summaryCard__plan">
          <div className="summaryCard__planName">Arcade</div>
          <button className="summaryCard__changeBtn" onClick={()=>dispatch(setStep(2))}>Change</button>
        </div>

        <div className="summaryCard__planPrice">
          {planDuration === "Yearly" ? `$${plan.yearlyPrice}/yr` : `$${plan.price}/mo`}
        </div>

        <hr className="summaryCard__divider" />

        {/* Add-ons */}
       

        {addOns.map((item, val) => {
          return item.checked ? (
            <div className="summaryCard__addon" key={val}>
              <span>{item.addOnInfo}</span>
              <span>
                {planDuration === "Yearly"
                  ? `$${item.yearlyPrice}/yr`
                  : `$${item.price}/mo`}
              </span>
            </div>
          ) : null;
        })}

       

        {/* Total */}
        <div className="summaryCard__total">
          <span>Total</span>
          <span>${Total}</span>
        </div>

      </div>

    </div>
  )
}

export default Summary